import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import './PasswordRules.css';

interface PasswordRulesProps {
  password: string;
  confirmPassword: string;
}

export function PasswordRules({ password, confirmPassword }: PasswordRulesProps) {
  const { t } = useTranslation();

  const rules = [
    { key: 'passwordTooShort', ok: password.length >= 8 && password.length <= 14 },
    { key: 'passwordMissingUppercase', ok: /[A-Z]/.test(password) },
    { key: 'passwordMissingDigit', ok: /[0-9]/.test(password) },
    { key: 'passwordMissingSpecial', ok: /[!@#$%^&*]/.test(password) },
    { key: 'passwordsDontMatch', ok: password.length > 0 && password === confirmPassword },
  ];

  return (
    <ul className="auth-rules">
      {rules.map((rule) => (
        <li key={rule.key} className={`auth-rules__item${rule.ok ? ' auth-rules__item--ok' : ''}`}>
          <span className="auth-rules__bullet" aria-hidden="true">
            {rule.ok && <Check size={9} strokeWidth={3.5} />}
          </span>
          {t(`general.${rule.key}`)}
        </li>
      ))}
    </ul>
  );
}
